import React from 'react'
import { useTrackPage } from 'services/Analytics'
import './content.scss'

const Content = ({ children }: { children: React.ReactNode }) => {
  useTrackPage()
  return (
    <div className="main">
      <div className="main-box">{children}</div>
    </div>
  )
}

export default Content
